var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactorialHrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsX: "ns_extend;",
    xmlnsI: "ns_ai;",
    xmlnsGraph: "ns_graphs;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#FF355E;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FF355E;}\n ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 99.8,
    y: -221.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.2,37.3c-3.7,3-8.4,4.7-13.2,4.7c-4.8,0-9.5-1.6-13.2-4.7c3.7-3,8.4-4.7,13.2-4.7 C26,32.6,30.6,34.4,34.2,37.3L34.2,37.3z M34.2,37.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.7,32.2C5,29.1,3.5,25.1,3.6,21c0-9.6,7.8-17.4,17.4-17.4c9.6,0,17.4,7.8,17.4,17.4c0,4.3-1.5,8.2-4.1,11.2 c0.9,0.6,1.7,1.2,2.5,1.8l0.3,0.3C40.3,30.6,42,25.9,42,21C42,9.4,32.6,0,21,0S0,9.4,0,21c0,4.9,1.7,9.6,4.8,13.3l0.3-0.3 C5.9,33.4,6.8,32.8,7.7,32.2L7.7,32.2z M7.7,32.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,20.4c0,4.3-3.5,7.8-7.8,7.8s-7.8-3.5-7.8-7.8c0-4.3,3.5-7.8,7.8-7.8S28.8,16.1,28.8,20.4L28.8,20.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactorialHrLogo);
export default __webpack_public_path__ + "static/media/factorialHRLogo.5527c39c174f6ffa2632cc309a89067f.svg";
export { ForwardRef as ReactComponent };